
import EscortList from "./list";


if (document.body.getAttribute("data-current-path") === "escorts") {
    const action = document.body.getAttribute("data-current-action")
    if (action === "index") {
        new EscortList();
    }
}